import { render, staticRenderFns } from "./IconFont.vue?vue&type=template&id=701ce99d&"
import script from "./IconFont.vue?vue&type=script&lang=ts&"
export * from "./IconFont.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports